import { render, staticRenderFns } from "./editCheckboxes.vue?vue&type=template&id=54a7314b&scoped=true"
import script from "./editCheckboxes.vue?vue&type=script&lang=js"
export * from "./editCheckboxes.vue?vue&type=script&lang=js"
import style0 from "./editCheckboxes.vue?vue&type=style&index=0&id=54a7314b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a7314b",
  null
  
)

export default component.exports